import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ProductGrid } from '../components/ProductGrid';
import { useCommerce } from '../contexts/CommerceContext';

export function FavoritesPage() {
  const { products, favorites } = useCommerce();
  const favoriteProducts = products.filter((product) => favorites.includes(product.id));
  return <main className="page-shell favorites-page"><header className="page-intro"><p className="eyebrow">Favoritos</p><h1>Suas peças salvas.</h1><p>Volte quando quiser para encontrar as escolhas que você amou.</p></header>{favoriteProducts.length ? <ProductGrid products={favoriteProducts} /> : <div className="empty-state"><Heart size={30} /><p>Você ainda não salvou nenhuma peça.</p><Link className="button button-dark" to="/fitness">Explorar fitness</Link></div>}</main>;
}
